import { render, staticRenderFns } from "./BusinessValidationForm.vue?vue&type=template&id=16d0ada8"
import script from "./BusinessValidationForm.vue?vue&type=script&lang=js"
export * from "./BusinessValidationForm.vue?vue&type=script&lang=js"
import style0 from "./BusinessValidationForm.vue?vue&type=style&index=0&id=16d0ada8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports